import {useCache} from './use_cache'

export const useUnpinnedColumns = ({tableName}) => {
	return useCache({tableName}).unpinned || []
}
